import React from "react";

import { useWrapExperienceCardContext } from "./WrapExperienceContext";
import WrapExperienceTextTitle from "./WrapExperienceTextTitle";

const WrapExperienceTitle = () => {
  const { card } = useWrapExperienceCardContext();

  return <WrapExperienceTextTitle>{card.name}</WrapExperienceTextTitle>;
};

export default WrapExperienceTitle;
